module.exports = __webpack_public_path__ + "static/img/product_4_2.46d410f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_4_2.png
// module id = GVa6
// module chunks = 34